export default {
  namespaced: true,
  state: {
    list: [],
    add: false,
    edit: false,
    editObj: {},
    branding: false,
    brandingObj: {},
    delete: false,
    deleteObj: {},
    businessUser: false,
    businessUserObj: {},
    businessLocation: false,
    businessLocationObj: {},
  },
  getters: {
    list: state => state.list,
    add: state => state.add,
    edit: state => state.edit,
    editObj: state => state.editObj,
    branding: state => state.branding,
    brandingObj: state => state.brandingObj,
    delete: state => state.delete,
    deleteObj: state => state.deleteObj,
    businessUser: state => state.businessUser,
    businessUserObj: state => state.businessUserObj,
    businessLocation: state => state.businessLocation,
    businessLocationObj: state => state.businessLocationObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addMutate(state, data) {
      state.add = data;
    },
    editMutate(state, data) {
      state.edit = data;
    },
    editObjMutate(state, data) {
      state.editObj = data;
    },
    brandingMutate(state, data) {
      state.branding = data;
    },
    brandingObjMutate(state, data) {
      state.brandingObj = data;
    },
    deleteMutate(state, data) {
      state.delete = data;
    },
    deleteObjMutate(state, data) {
      state.deleteObj = data;
    },
    businessUserMutate(state, data) {
      state.businessUser = data;
    },
    businessUserObjMutate(state, data) {
      state.businessUserObj = data;
    },
    businessLocationMutate(state, data) {
      state.businessLocation = data;
    },
    businessLocationObjMutate(state, data) {
      state.businessLocationObj = data;
    },
  },
  actions: {
    setList(context, data) {
      context.commit('listMutate', data);
    },
    setAdd(context, data) {
      context.commit('addMutate', data);
    },
    setEdit(context, data) {
      context.commit('editMutate', data);
    },
    setEditObj(context, data) {
      context.commit('editObjMutate', data);
    },
    setBranding(context, data) {
      context.commit('brandingMutate', data);
    },
    setBrandingObj(context, data) {
      context.commit('brandingObjMutate', data);
    },
    setDelete(context, data) {
      context.commit('deleteMutate', data);
    },
    setDeleteObj(context, data) {
      context.commit('deleteObjMutate', data);
    },
    setBusinessUser(context, data) {
      context.commit('businessUserMutate', data);
    },
    setBusinessUserObj(context, data) {
      context.commit('businessUserObjMutate', data);
    },
    setBusinessLocation(context, data) {
      context.commit('businessLocationMutate', data);
    },
    setBusinessLocationObj(context, data) {
      context.commit('businessLocationObjMutate', data);
    },
  },
};
